import { useEffect } from 'react';

interface QueryResultWithRefetch {
  refetch: (...args: never[]) => unknown;
}

export function useRefetchOnWindowFocusQuery<TResult extends QueryResultWithRefetch, TOptions>(
  useQueryHook: (options: TOptions) => TResult,
  options: TOptions,
): TResult {
  const result = useQueryHook(options);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        result.refetch();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [result.refetch]);

  return result;
}
